import { useMutation, useQueryClient } from 'react-query'

import { duplicateExpenseUseCase } from '@webapp/modules/expense/business-logic/use-cases/DuplicateExpense'
import { expenseQueryConfig } from '@webapp/modules/expense/query-configs/expense'

export const useMutateDuplicateExpenseReport = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async ({
      id,
      confirmOverwriteDraft,
    }: {
      id: number
      confirmOverwriteDraft?: boolean
    }) => {
      return duplicateExpenseUseCase({ id, confirmOverwriteDraft })
    },
    onSuccess: () => {
      queryClient.resetQueries(expenseQueryConfig.requestFormData().queryKey)
      queryClient.resetQueries(expenseQueryConfig.drafts().queryKey)
    },
  })

  return {
    mutate: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
